import { CategoryRepository } from '../../domain/repositories/category.repository';
import { CategoryEntity } from '../../domain/entities/category.entity';

export class ToggleCategoryStatusUseCase {
  constructor(private readonly categoryRepository: CategoryRepository) {}

  async execute(id: string, status: boolean): Promise<CategoryEntity> {
    if (this.categoryRepository.toggleCategoryStatus) {
      return this.categoryRepository.toggleCategoryStatus(id, status);
    }
    return this.categoryRepository.changeCategoryStatus(id, status);
  }
}
